import React, { useEffect, useState } from 'react';
import { ReactSVG } from 'react-svg';
import { Link } from 'react-router-dom';
import { Form, Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';

import { signupRequest } from '../../Common/requests'
import { usePostHog } from '@posthog/react';

import ArrowSVG from '../../assets/icons/arrow-up.svg'
import SimpleReactValidator from "simple-react-validator";

import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import { useTranslation } from 'react-i18next';

const Signup = () => {
    const { t } = useTranslation('marketplace');
    const posthog = usePostHog();
    const [signup, setSignup] = useState(false);
    const [validator] = useState(new SimpleReactValidator());
    const [disabled, setDisabled] = useState(false);
    const [, forceUpdate] = useState();

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [termsCheck, setTermsCheck] = useState(false);

    const [showPassword, setShowPassword] = useState(false)
    const [showCPassword, setShowCPassword] = useState(false)


    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    const handleSignup = async (evt) => {
        if (typeof evt !== "undefined" && evt != null) {
            evt.preventDefault();
        }

        if (!validator.allValid()) {
            validator.showMessages();
            forceUpdate(1);
            setDisabled(false);
        } else if (!email && !phone) {
            toast.error(t('auth.phoneOrEmailRequired'));
            setDisabled(false);
        } else {
            setDisabled(true);
            let data = { email: email, password: password, name: { firstName: firstName, lastName: lastName }, mobilePhone: phone };
            const result = await signupRequest(data);
            if (result?.success) {
                posthog?.identify(String(result.user.id), {
                    name: `${firstName} ${lastName}`,
                });
                posthog?.capture('user_signed_up');
            }
            setDisabled(false);
        }
    }

    return (
        <div className={`auth-page ${signup ? "signup-form" : ""}`}>
            <div className="container">
                <div className="block-content inner-head">
                    <Link className="icon" to="/">
                        <ReactSVG src={ArrowSVG} />
                    </Link>
                </div>
                {signup ?
                    <div className="block-content content-holder">
                        <form onSubmit={handleSignup} noValidate>
                            <Row>
                                <Col lg={6} sm={12}>
                                    <div className="form-group">
                                        <label>{t('auth.firstName')}</label>
                                        <input type="text" className="form-control" placeholder={t('auth.firstNamePlaceholder')} value={firstName} onChange={(e) => { setFirstName(e.target.value) }} />
                                        {validator.message(
                                            "first_name",
                                            firstName,
                                            "required|alpha_space",
                                            { className: "text-danger" }
                                        )}
                                    </div>
                                </Col>
                                <Col lg={6} sm={12}>
                                    <div className="form-group">
                                        <label>{t('auth.lastName')}</label>
                                        <input type="text" className="form-control" placeholder={t('auth.lastNamePlaceholder')} value={lastName} onChange={(e) => { setLastName(e.target.value) }} />
                                        {validator.message(
                                            "last_name",
                                            lastName,
                                            "required|alpha_space",
                                            { className: "text-danger" }
                                        )}
                                    </div>
                                </Col>
                                <Col lg={6} sm={12}>
                                    <div className="form-group">
                                        <label>{t('auth.phoneNumber')}</label>
                                        <PhoneInput
                                            international
                                            countryCallingCodeEditable={true}
                                            countrySelectProps={{ unicodeFlags: true }}
                                            defaultCountry="AU"
                                            value={phone}
                                            onChange={(number) => setPhone(number)}
                                            placeholder={t('auth.phoneNumberPlaceholder')}
                                        />
                                        {validator.message(
                                            "phone",
                                            phone,
                                            "phone",
                                            { className: "text-danger" }
                                        )}
                                    </div>
                                </Col>
                                <Col lg={6} sm={12}>
                                    <div className="form-group">
                                        <label>{t('auth.emailAddress')}</label>
                                        <input type="email" name='email' className="form-control" placeholder={t('auth.emailAddressPlaceholder')} value={email} onChange={(e) => { setEmail(e.target.value) }} autoComplete='email' />
                                        {validator.message(
                                            "email",
                                            email,
                                            "email",
                                            { className: "text-danger" }
                                        )}
                                    </div>
                                </Col>
                                <Col lg={6} sm={12}>
                                    <div className="form-group">
                                        <label>{t('auth.passwordCreate')}</label>
                                        <input  type={showPassword ? "text" : "password"} className="form-control" placeholder={t('auth.passwordCreatePlaceholder')} value={password} onChange={(e) => { setPassword(e.target.value) }} autoComplete='new-password' />
                                        {validator.message(
                                            "password",
                                            password,
                                            "required|min:8",
                                            { className: "text-danger" }
                                        )}
                                        <span className="form-icon" onClick={() => setShowPassword(!showPassword)}>
                                            {showPassword ? <AiFillEye /> : <AiFillEyeInvisible />}
                                        </span>
                                    </div>
                                </Col>
                                <Col lg={6} sm={12}>
                                    <div className="form-group">
                                        <label>{t('auth.confirmPassword')}</label>
                                        <input  type={showCPassword ? "text" : "password"} className="form-control" placeholder={t('auth.confirmPasswordPlaceholder')} value={confirmPassword} onChange={(e) => { setConfirmPassword(e.target.value) }} autoComplete='new-password' />
                                        {validator.message(
                                            "confirm_password",
                                            confirmPassword,
                                            `required|min:8|in:${password}`,
                                            {
                                                className: "text-danger",
                                                messages: { in: t('auth.passwordsDoNotMatch') }
                                            }
                                        )}
                                        <span className="form-icon" onClick={() => setShowCPassword(!showCPassword)}>
                                            {showCPassword ? <AiFillEye /> : <AiFillEyeInvisible />}
                                        </span>
                                    </div>
                                </Col>
                            </Row>
                            <div className="flex align-items-center">
                                <Form.Check className="checkbox" type="checkbox" checked={termsCheck} onChange={() => setTermsCheck(!termsCheck)} />
                                <h6 className="m-0">{t('auth.agreeToPrivacy')} <a target="_blank" rel="noopener noreferrer" href="https://partner.retainoo.com/privacy-policy/" className="link">{t('auth.privacyPolicyLink')}</a></h6>
                            </div>
                            <div className="button-holder mt-3">
                                <button type="submit" className="btn btn-secondary" disabled={(!termsCheck)}>{t('auth.signUp')}</button>
                            </div>
                        </form>
                        <div className="text-center mt-4">
                            <h6 className="text-grey">{t('auth.alreadyHaveAccount')}</h6>
                            <Link className="link" to="/login">{t('auth.loginNow')}</Link>
                        </div>
                    </div>
                    :
                    <div className="block-content content-holder">
                        <div className="">
                            <h5>{t('auth.signupHeading')}</h5>
                            <h6 className="text-grey">{t('auth.loginSubheading')}</h6>
                        </div>
                        <div className="buttons-group">
                            <button className="btn btn-secondary" onClick={() => setSignup(!signup)}>{t('auth.signUp')}</button>
                        </div>
                        <div className="text-center">
                            <h6 className="text-grey">{t('auth.alreadyHaveAccount')}</h6>
                            <Link className="link" to="/login">{t('auth.loginNow')}</Link>
                        </div>
                    </div>
                }
                <h6 className="text-grey text-center"> {t('auth.copyrightNotice')}</h6>
            </div>
        </div>
    );
}

export default Signup;
